import React from 'react';
import { DollarSign, Zap, Users, Headphones, TrendingUp, Smartphone } from 'lucide-react';
import { whyChooseUs } from '../mock';

const iconMap = {
  DollarSign,
  Zap,
  Users,
  Headphones,
  TrendingUp,
  Smartphone
};

const WhyChooseUs = () => {
  return (
    <section id="why-choose" className="py-20 px-4" style={{ background: 'var(--bg-section)' }}>
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="heading-2 mb-4">Why Choose Froma Web?</h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            We make digital marketing simple and affordable for small businesses
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {whyChooseUs.map((feature) => {
            const Icon = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className="bg-[var(--bg-card)] border border-[var(--border-light)] rounded-xl p-6 transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
              >
                {/* Icon */}
                <div
                  className="w-14 h-14 rounded-full flex items-center justify-center mb-4"
                  style={{ background: 'var(--accent-wash)' }}
                >
                  <Icon size={28} style={{ color: 'var(--accent-text)' }} />
                </div>

                {/* Title */}
                <h3 className="heading-3 mb-3">{feature.title}</h3>

                {/* Description */}
                <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
